/* FIVE AM · revelado al hacer scroll y montador de set (miniaturas + desbloqueos). */
(function(){
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.body.classList.add('fa-js');
  var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('fa-in'); io.unobserve(e.target); } }); }, {threshold:.12});
  function reveal(){ document.querySelectorAll('.fa .fa-rv:not(.fa-in)').forEach(function(el){ io.observe(el); }); }
  reveal(); document.addEventListener('shopify:section:load', reveal);

  /* montador de set. ponytail: los tramos son datos de la sección; el descuento real lo aplica Shopify en el pago.
     26/09/2026: el umbral de envío gratis viene de data-free (sections/fa-set), no de un 150 escrito aquí. */
  var tiles = document.getElementById('fa-tiles');
  if (tiles) {
    var b = tiles.closest('.fa-builder'), q = {}, T = tiles.querySelectorAll('.fa-tile');
    var t2 = +b.dataset.tier2 || 3, p2 = (+b.dataset.tier2Pct || 10)/100, t3 = +b.dataset.tier3 || 5, p3 = (+b.dataset.tier3Pct || 15)/100;
    var free = +b.dataset.free || 55;
    var thumbs = document.getElementById('fa-thumbs');
    var eur = function(n){ return n.toFixed(2).replace('.', ',') + ' €'; };
    function rate(i){ return i >= t3 ? p3 : i >= t2 ? p2 : 0; }
    function renderThumbs(){
      thumbs.innerHTML = '';
      T.forEach(function(t){
        var id = t.dataset.id, n = q[id] || 0;
        for (var k = 0; k < n; k++) {
          var th = document.createElement('span');
          th.className = 'fa-panel__thumb';
          th.dataset.id = id;
          if (t.dataset.img) th.style.backgroundImage = 'url(' + t.dataset.img + ')';
          th.innerHTML = '<button type="button" class="fa-panel__thumb-x" aria-label="Quitar ' + t.dataset.name + '">×</button>';
          thumbs.appendChild(th);
        }
      });
    }
    function render(){
      var items = 0, sub = 0;
      T.forEach(function(t){ var id = t.dataset.id, n = q[id] || 0, p = parseFloat(t.dataset.p); items += n; sub += n*p; t.classList.toggle('fa-tile--on', n > 0);
        if (t.dataset.soldout) return;
        t.querySelector('.fa-tile__qty').innerHTML = n === 0 ? '<button type="button" class="fa-tile__add">Añadir al set</button>' : '<button type="button" class="fa-tile__m" aria-label="Quitar uno">−</button><output>'+n+'</output><button type="button" class="fa-tile__pl" aria-label="Añadir uno">+</button>'; });
      var dis = sub*rate(items), tot = sub - dis;
      document.getElementById('fa-cnt').textContent = '(' + Math.min(items, t3) + '/' + t3 + ')';
      document.getElementById('fa-barfill').style.transform = 'scaleX(' + Math.min(items, t3)/t3 + ')';
      document.getElementById('fa-sub').textContent = eur(sub);
      document.getElementById('fa-dis').textContent = (dis ? '−' : '') + eur(dis);
      document.getElementById('fa-tot').textContent = eur(tot);
      document.getElementById('fa-t1').classList.toggle('fa-hit', tot >= free);
      document.getElementById('fa-t2').classList.toggle('fa-hit', items >= t2);
      document.getElementById('fa-t3').classList.toggle('fa-hit', items >= t3);
      renderThumbs();
      var ab = document.getElementById('fa-addset'); ab.disabled = items === 0; ab.textContent = items ? 'Añadir a la cesta · ' + eur(tot) : 'Añadir a la cesta · 0,00 €';
    }
    tiles.addEventListener('click', function(e){ var bt = e.target.closest('button'); if(!bt) return; var id = bt.closest('.fa-tile').dataset.id;
      if (bt.classList.contains('fa-tile__add') || bt.classList.contains('fa-tile__pl')) q[id] = (q[id]||0) + 1;
      if (bt.classList.contains('fa-tile__m')) q[id] = Math.max(0, (q[id]||0) - 1);
      render(); });
    thumbs.addEventListener('click', function(e){ var bt = e.target.closest('.fa-panel__thumb-x'); if(!bt) return; var id = bt.closest('.fa-panel__thumb').dataset.id;
      q[id] = Math.max(0, (q[id]||0) - 1); render(); });
    document.getElementById('fa-addset').addEventListener('click', function(){
      var items = []; for (var k in q) if (q[k] > 0) items.push({id: +k, quantity: q[k]});
      if (!items.length) return; var ab = this; ab.disabled = true; ab.textContent = 'Añadiendo…';
      fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items})})
        .then(function(r){ if(!r.ok) throw new Error('add'); location.href = '/cart'; })
        .catch(function(){ ab.disabled = false; ab.textContent = 'No se pudo añadir. Inténtalo otra vez.'; });
    });
    render();
  }
})();

/* Cabecera siempre en modo cajon, como rascalsco.com. Horizon lo decide por
   ancho y por si hay tactil (layout/theme.liquid); aqui se fija y se vigila. */
(function(){
  function force(){
    var h = document.getElementById('header-component');
    if (h && h.dataset.menuStyle !== 'drawer') h.dataset.menuStyle = 'drawer';
    return h;
  }
  var h = force();
  if (h) new MutationObserver(force).observe(h, {attributes: true, attributeFilter: ['data-menu-style']});
  document.addEventListener('DOMContentLoaded', force);
  document.addEventListener('shopify:section:load', force);
  addEventListener('resize', force, {passive: true});
})();

/* ---- Interfaz: progreso, volver arriba, UTM, copiar, confirmar ---- */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Barra de progreso de lectura
  var bar = document.querySelector('.fa-progress__bar');
  var top = document.querySelector('.fa-totop');
  function onScroll() {
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var y = h.scrollTop || document.body.scrollTop;
    if (bar) bar.style.width = (max > 0 ? (y / max) * 100 : 0) + '%';
    if (top) {
      var show = y > 600;
      top.hidden = !show;
      top.classList.toggle('is-on', show);
    }
  }
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  onScroll();

  if (top) {
    top.addEventListener('click', function () {
      scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  // UTM: se guardan al aterrizar y viajan al WhatsApp, para saber que campana
  // trajo la conversacion. Solo en esta pestana, no se envia a nadie mas.
  try {
    var qs = new URLSearchParams(location.search);
    var utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      if (qs.get(k)) utm[k] = qs.get(k);
    });
    if (Object.keys(utm).length) sessionStorage.setItem('fa_utm', JSON.stringify(utm));
    var saved = JSON.parse(sessionStorage.getItem('fa_utm') || '{}');
    if (saved.utm_source) {
      document.querySelectorAll('a[href^="https://wa.me/"]').forEach(function (a) {
        var u = new URL(a.href);
        if (!u.searchParams.get('text')) {
          u.searchParams.set('text', 'Hola, vengo de ' + saved.utm_source +
            (saved.utm_campaign ? ' (' + saved.utm_campaign + ')' : ''));
          a.href = u.toString();
        }
      });
    }
  } catch (e) { /* sessionStorage puede estar bloqueado: no es critico */ }

  // Estado de carga en cualquier formulario de anadir a la cesta
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.action || f.action.indexOf('/cart/add') === -1) return;
    var b = f.querySelector('[type="submit"]');
    if (b) {
      b.setAttribute('aria-busy', 'true');
      setTimeout(function () { b.removeAttribute('aria-busy'); }, 4000);
    }
  }, true);
})();

/* ---- Muestras de color (Nike): al pasar el ratón por un punto, la tarjeta enseña esa variante ---- */
(function () {
  function swap(s) {
    var card = s.closest('.fa-card, .fa-slider__item, product-card');
    if (!card) return;
    var img = card.querySelector('.fa-card__ph img, .fa-slider__ph img, .card-gallery img');
    if (img && s.dataset.img && img.getAttribute('src') !== s.dataset.img) {
      img.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = function () { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = s.dataset.img; img.alt = s.dataset.alt || img.alt; img.classList.remove('is-swapping'); };
      pre.onerror = function () { img.classList.remove('is-swapping'); };
      pre.src = s.dataset.img;
    }
    card.querySelectorAll('.fa-swatch').forEach(function (x) { x.classList.toggle('is-on', x === s); });
    // Colecciones: el «Añadir» mete la variante de la muestra y «Échale un ojo» la abre (solo si hay stock)
    var qa = card.querySelector('.fa-qa');
    if (qa) {
      var off = s.hasAttribute('data-soldout'), vid = qa.querySelector('input[name="id"]'), add = qa.querySelector('button.fa-qa__add');
      if (vid && s.dataset.variant && !off) vid.value = s.dataset.variant;
      if (add && vid) add.disabled = off;
      if (s.href) qa.dataset.url = s.href;
    }
    card.querySelectorAll('.fa-card__ph, .fa-slider__ph, .fa-card__body h3 a, .fa-slider__name a, .fa-card__row a.fa-btn').forEach(function (a) { if (s.href) a.href = s.href; });
  }
  document.addEventListener('mouseover', function (e) { var s = e.target.closest('.fa-swatch'); if (s) swap(s); });
  document.addEventListener('focusin', function (e) { var s = e.target.closest('.fa-swatch'); if (s) swap(s); });
  document.addEventListener('touchstart', function (e) { var s = e.target.closest('.fa-swatch'); if (s) { e.preventDefault(); swap(s); } }, { passive: false });
})();

/* ---- Carrusel de la cesta (Apple): flechas, puntos y orden por recomendaciones de Shopify ----
   Primero lo que Shopify recomienda para lo que ya hay en la cesta; el resto del catálogo detrás, en orden aleatorio. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('.fa-slider__track');
    var prev = root.querySelector('.fa-slider__arrow--prev');
    var next = root.querySelector('.fa-slider__arrow--next');
    var dots = root.querySelector('.fa-slider__dots');
    if (!track) return;
    function pages() { return Math.max(1, Math.round((track.scrollWidth - 8) / track.clientWidth)); }
    function page() { return Math.min(pages() - 1, Math.round(track.scrollLeft / track.clientWidth)); }
    function paint() {
      var n = pages(), p = page();
      if (dots) {
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button'; b.dataset.i = i; b.setAttribute('aria-label', 'Ir al grupo ' + (i + 1) + ' de ' + n);
          if (i === p) { b.className = 'is-on'; b.setAttribute('aria-current', 'true'); }
          dots.appendChild(b);
        }
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      root.classList.toggle('fa-slider--single', n <= 1);
    }
    function go(x) { track.scrollTo({ left: x, behavior: reduce ? 'auto' : 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(track.scrollLeft - track.clientWidth * 0.9); });
    if (next) next.addEventListener('click', function () { go(track.scrollLeft + track.clientWidth * 0.9); });
    if (dots) dots.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) go(b.dataset.i * track.clientWidth); });
    track.addEventListener('scroll', paint, { passive: true });
    addEventListener('resize', paint, { passive: true });

    var ids = (root.dataset.cart || '').split(',').filter(Boolean);
    var items = [].slice.call(track.children);
    var score = {};
    items.forEach(function (li) { score[li.dataset.handle] = Math.random(); });
    Promise.all(ids.map(function (id) {
      return fetch('/recommendations/products.json?product_id=' + id + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { return { products: [] }; });
    })).then(function (res) {
      res.forEach(function (d) { (d.products || []).forEach(function (p, i) { if (p.handle in score) score[p.handle] += 10 - i; }); });
      items.sort(function (a, b) { return score[b.dataset.handle] - score[a.dataset.handle]; }).forEach(function (li) { track.appendChild(li); });
      track.scrollLeft = 0;
      paint();
    });
    paint();
  }
  var pending = false;
  function init() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; document.querySelectorAll('.fa-slider').forEach(setup); });
  }
  init();
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ---- Ficha: «Pagar con tarjeta» y «Más opciones de pago» sustituyen a «Comprar con Shop».
   Añaden lo que hay en el formulario de la ficha y van al pago, donde Shopify enseña tarjeta, Apple Pay, Google Pay y PayPal. ---- */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fa-checkout]');
    if (!b) return;
    var f = document.querySelector('form[id^="BuyButtons-ProductForm-"]');
    if (!f) return;
    e.preventDefault();
    var id = f.querySelector('[name="id"]'), q = f.querySelector('[name="quantity"]');
    if (!id) return;
    b.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id.value, quantity: q ? (+q.value || 1) : 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); location.href = '/checkout'; })
      .catch(function () { b.removeAttribute('aria-busy'); location.href = '/cart'; });
  });
})();

/* ---- «Échale un ojo»: la vista rápida de Horizon abre la URL de data-url (la variante de la muestra elegida) ---- */
customElements.whenDefined('quick-add-component').then(function (C) {
  var d = Object.getOwnPropertyDescriptor(C.prototype, 'productPageUrl');
  if (!d || !d.get || C.prototype.__fa) return;
  C.prototype.__fa = true;
  Object.defineProperty(C.prototype, 'productPageUrl', { configurable: true, get: function () {
    return this.dataset.url ? new URL(this.dataset.url, location.origin).href : d.get.call(this);
  } });
});